/**
 * VenturaZ — client-side mirror of `backend/services/trust_badge.py`.
 * Keep the two in sync — any rule change here must be applied there too.
 *
 * Rules:
 *   • Hard gate: startup.kyc_status === "Approved" — else no badge.
 *   • Count = # of green checks in (Aadhaar, CIN, GSTIN).
 *   • Tier: 3 → gold ("VenturaZ Verified"), 2 → silver, 1 → bronze, 0 → null.
 */

export const TIER_LABELS = {
  gold: "VenturaZ Verified",
  silver: "Partly Verified",
  bronze: "Identity Started",
};

export function computeTrustBadge(startup) {
  const s = startup || {};
  const checks = {
    aadhaar: !!s.founder_id_verified,
    cin: !!s.cin_verified_at,
    gstin: !!s.gstin_verified_at,
  };
  const count = Object.values(checks).filter(Boolean).length;
  const kyc_approved = s.kyc_status === "Approved";
  if (!kyc_approved || count === 0) {
    return { tier: null, label: null, checks, count, kyc_approved };
  }
  const tier = count >= 3 ? "gold" : count === 2 ? "silver" : "bronze";
  return { tier, label: TIER_LABELS[tier], checks, count, kyc_approved };
}
